<template>
  <v-app>
    <!-- App Bar -->
    <v-app-bar color="light-blue lighten-4" dark app>
      <v-app-bar-nav-icon
        v-if="smAndDown"
        @click.stop="temporary = !temporary"
        color="grey darken-3"
      >
      </v-app-bar-nav-icon>
      <v-toolbar-title v-if="smAndDown" class="grey--text text--darken-3">
        ITC Finance
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text icon color="grey darken-3" v-on="on">
            <v-icon>mdi-account-circle</v-icon>
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <div>
              <span class="subtitle-2 d-block">
                Selamat datang, {{ userName }}
              </span>
              <span class="d-block text-center">
                <v-btn small text @click="logout" color="red">
                  <span>
                    KELUAR
                    <v-icon>mdi-logout</v-icon>
                  </span>
                </v-btn>
              </span>
            </div>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <!-- End App Bar -->

    <!-- Navigation Drawer -->
    <v-navigation-drawer
      app
      color="light-blue lighten-4"
      floating
      :permanent="mdAndUp"
      :temporary="smAndDown"
      :value="mdAndUp || temporary"
      @input="changeTemporary($event)"
    >
      <v-list-item>
        <v-list-item-content>
          <v-img :src="navLogo" :max-width="imageWidth" class="mx-auto">
          </v-img>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list>
        <template v-for="menu in menus">
          <v-list-item
            color="primary"
            v-if="!menu.submenus"
            :key="menu.title"
            :to="menu.link"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.action }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="menu.title" />
          </v-list-item>
          <v-list-group
            v-else
            :prepend-icon="menu.action"
            :key="menu.title"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="menu.title" />
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(submenu, i) in menu.submenus"
              :key="i"
              :to="submenu.link"
            >
              <v-list-item-content>
                <v-list-item-title v-text="submenu.title" />
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    <!-- End Navigation Drawer --->

    <v-content>
      <transition name="fade">
        <router-view @willExitPage="handleWillExitPage"></router-view>
      </transition>
    </v-content>

    <v-overlay :value="overlay" z-index="6">
      <v-progress-circular
        indeterminate
        size="64"
        color="light-blue lighten-4"
      ></v-progress-circular>
      <span v-if="showText" class="light-blue--text text--lighten-4 ml-4">
        Cleaning Up Editor
      </span>
    </v-overlay>
  </v-app>
</template>

<script>
import { lsUtils } from "@/utils/localStorageUtils";
import navLogo from "@/assets/nav-logo.png";

export default {
  beforeRouteEnter(to, from, next) {
    const userToken = lsUtils.getItem("userToken");
    if (userToken) {
      next();
    } else {
      next((vm) => {
        vm.$router.replace("/login");
      });
    }
  },
  name: "App",
  computed: {
    imageWidth() {
      return this.$vuetify.breakpoint.smAndDown ? 150 : 180;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    mdAndUp() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    userName() {
      if (Object.keys(this.account).length) {
        return (
          this.account.userData.userName.charAt(0).toUpperCase() +
          this.account.userData.userName.slice(1)
        );
      }
      return "";
    },
  },
  components: {},
  data() {
    return {
      account: lsUtils.getItem("userToken"),
      overlay: false,
      temporary: false,
      menus: [
        {
          action: "mdi-view-dashboard",
          title: "Dashboard",
          link: "/",
        },
        {
          action: "mdi-newspaper",
          title: "News",
          submenus: [
            { title: "Add", link: "/news/add" },
            { title: "Edit", link: "/news/edit" },
          ],
        },
        {
          action: "mdi-account-check",
          title: "Role",
          submenus: [
            { title: "Add", link: "/role/add" },
            { title: "Edit", link: "/role/edit" },
          ],
        },
        {
          action: "mdi-account-edit",
          title: "User",
          submenus: [
            { title: "Add", link: "/user/add" },
            { title: "Edit", link: "/user/edit" },
          ],
        },
      ],
      navLogo,
      showText: false,
    };
  },
  methods: {
    logout() {
      this.overlay = true;
      setTimeout(async () => {
        lsUtils.removeItem("userToken");
        await this.$apollo.provider.defaultClient.clearStore();
        this.overlay = false;
        this.$router.push("/login");
      }, 1500);
    },
    changeTemporary(val) {
      if (!this.mdAndUp) {
        this.temporary = val;
      }
    },
    handleWillExitPage(e) {
      this.showText = e;
      this.overlay = e;
    },
  },
  watch: {
    mdAndUp: {
      immediate: true,
      handler: function (n) {
        if (n) {
          if (this.temporary) {
            this.temporary = false;
          }
        }
      },
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
